module.exports = __webpack_public_path__ + "static/img/headerImgCn.48bff58e.png";